<template>
  <div class="principal-caja-dorada">
    <!-- Modal Archivo-->
    <div
      class="modal fade"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      id="modalArchivo"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content modal-archivo">
          <div class="modal-header modal-archivo__encabezado">
            <h5 class="modal-title">{{ this.tituloDocumento }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <iframe
              id="iframeDocumento"
              class="pdf-archivo"
              :src="this.ligaArchivo"
              type="content"
            ></iframe>
          </div>
          <div
            class="container text-start"
            v-if="tipoDocumentoArchivo != 20 && tipoDocumentoArchivo != 18 && tipoDocumentoArchivo != 39"
          >
            <div
              v-if="subiendoArchivo && soloLectura == false"
              style="display: flex; justify-content: center"
            >
              <v-progress-circular
                :size="30"
                :width="4"
                color="#b8725a"
                indeterminate
              ></v-progress-circular>
            </div>
            <div v-if="!subiendoArchivo && soloLectura == false">
              <div
                v-if="
                  (tipoUsuario != 5 &&
                    tipoUsuario != 8 &&
                    tipoUsuario != 9 &&
                    tipoUsuario != 10 &&
                    archivoLleno == null) ||
                    (tipoUsuario != 5 &&
                      tipoUsuario != 8 &&
                      tipoUsuario != 9 &&
                      tipoUsuario != 10 &&
                      archivoLleno != null)
                "
              >
                <label style="padding-left: 10px">
                  {{
                    tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                      ? "Una vez llenado y firmado el documento, descárgalo, guárdalo en tu equipo y súbelo en la sección abajo mencionada."
                      : "Once the document is completed and signed, download it, save it to your computer and upload it in the section below."
                  }}
                </label>
                <input
                  class="d-none"
                  type="file"
                  ref="inputDocumentoLleno"
                  @change="almacenarArchivoLleno"
                />
                <div class="col-lg-6">
                  <InputDocumentos
                    @click.native="activaInput()"
                    ajusteMarginBoton="margin-top: 0px !important"
                    :Documento="this.tipoDocumentoArchivo"
                    :NombreArchivo="LabelInputFile"
                    :esExtranjero="!(tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7)"
                  ></InputDocumentos>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary modal-archivo__boton"
              data-bs-dismiss="modal"
            >
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Cerrar"
                  : "Close"
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <titulo-seccion
      :titulo="
        tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
          ? 'KIT DE BIENVENIDA'
          : 'WELCOME KIT'
      "
    ></titulo-seccion>
    <div class="container contenedor-caja-dorada">
      <div class="row col-lg-12">
        <div class="col-lg-12">
          <p class="parrafo-instrucciones">
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Hola " +
                NombreUsuario + " " + ApellidoUsuario +
                  ", ¡Felicidades! Estas a un solo paso de terminar tu proceso de contratación, en esta sección te pedimos nos ayudes a llenar y firmar los siguientes documentos, estos también podrás visualizarlos y/o descargarlos las veces que desees."
                : "Hello " +
                NombreUsuario + " " + ApellidoUsuario +
                  ", Congratulations! You are just one step away from finishing your financing process, in this section we ask you to help us fill out and sign the following documents, you can also view and/or download them as many times as you wish."
            }}
          </p>
        </div>
      </div>
      <div class="row col-lg-12" style="text-align: left">
        <strong class="titulo-documentos">
          {{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "Contratos"
              : "Contracts"
          }}</strong
        >
        <div class="col-lg-12">
          <p class="parrafo-instrucciones">
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Para poder firmar los contratos únicamente deberás de seleccionar el botón “Firmar Contratos”, la firma digital es válida como si se firmará el documento en formato físico."
                : 'In order to sign the contracts you only have to select the "Sign Contracts" button, the digital signature is valid as if you were signing the document in physical format.'
            }}
          </p>
          
          <div class="row mx-0 mx-md-3 mx-lg-3" style="border:1px solid #B8725A ;" v-if="personasPendientesFirma.length > 0" >
            <div class="col-12 col-md-1 d-flex justify-content-center align-items-center" style="background-color: #B8725A;">
              <i class="fas fa-info-circle text-white" style="font-size: 32px;"></i>
            </div>
            <div class="col-12 col-md-11" style="background-color: rgba(179, 140, 79, 0.1);">
              
                  <p class="text-dark fw-bold" v-if="!puedeFirmarDocumentos && (this.tipoPersona == 0 || this.tipoPersona == 1 || this.tipoPersona == 3 || this.tipoPersona == 4 || this.tipoPersona == 6  ) ">
                Para proceder con la firma de contratos, es esencial completar el proceso de autenticación, 
                ya que esto es necesario para obtener las firmas tanto del titular como del cotitular. 
                <span  v-if="EstadoTitularSinIncodeValor">
                  Si aún no has realizado la autenticación,
                <v-btn  @click="goTo()" text color="primary" small class="text-wrap">haz clic aquí para comenzar.</v-btn>
                </span>
                <br>
                <span class="fw-light">Los siguientes personas están pendientes de realizar la autenticación:</span>
                <ul class="mt-3" style="list-style-type: none; color: #B8725A;">
                  <li v-for="(persona,index) in personasPendientesFirma" :key="index ">{{ persona.Nombre }}</li>
                </ul>
              </p>

              <p class="text-dark fw-bold" v-if="!puedeFirmarDocumentos && (  this.tipoPersona == 2 || this.tipoPersona == 5 || this.tipoPersona == 7)  ">
                To proceed with the signing of contracts, it is essential to complete the authentication process,
                as this is necessary to obtain the signatures of both the holder and the co-holder.
                <span v-if="EstadoTitularSinIncodeValor">
                  If you have not yet completed authentication, 
                  <v-btn  @click="goTo()" text color="primary" small class="text-wrap" >click here to begin.</v-btn>
                </span>
                <br>
                <span class="fw-light">The following people are pending authentication:</span>
                <ul class="mt-3" style="list-style-type: none; color: #B8725A;">
                  <li v-for="(persona,index) in personasPendientesFirma" :key="index ">{{persona.Nombre }}</li>
                </ul>
              </p>
            </div>

          </div>

        </div>
        <div v-if="Existe && FirmandoContratos == false">
          <div class="col-lg-12">
            <button
              class="boton--collapsable"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsableContratos"
              aria-expanded="false"
              aria-controls="collapseExample"
              v-if="!avisoCarga"
            >
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Ver contratos"
                  : "See contracts"
              }}
            </button>
            <div class="collapse" id="collapsableContratos">
              <div
                class="caja-manuales"
                v-if="ContratosFirmados || tipoPersona == 2 || tipoPersona == 1"
              >
                <div
                  class="caja-manuales__manual"
                  v-for="contrato in Contratos"
                  v-bind:key="contrato.archivoId"
                >
                  <button
                    @click.prevent="
                      VerContrato(
                        contrato.archivoId,
                        contrato.tipoDocumento,
                        contrato.nombreOriginal
                      )
                    "
                    class="caja-manules__boton"
                    data-bs-toggle="modal"
                    data-bs-target="#modalArchivo"
                  >
                    {{
                      contrato.tipoDocumento === 23
                        ? tipoPersona != 2 &&
                          tipoPersona != 5 &&
                          tipoPersona != 7
                          ? contrato.nombreOriginal
                          : contrato.nombreOriginal.replace(
                              "CONTRATO",
                              "CONTRACT"
                            )
                        : ObtenerTituloArchivo(contrato.tipoDocumento)
                    }}
                  </button>
                </div>
              </div>
              <div class="caja-manuales" v-else>
                <div
                  class="caja-manuales__manual"
                  v-for="contrato in Contratos"
                  v-bind:key="contrato.archivoId"
                >
                  <button
                    @click.prevent="
                      VerContrato(
                        contrato.archivoId,
                        contrato.tipoDocumento,
                        contrato.nombreOriginal
                      )
                    "
                    class="caja-manules__boton"
                    data-bs-toggle="modal"
                    data-bs-target="#modalArchivo"
                  >
                    {{
                      contrato.tipoDocumento === 23
                        ? tipoPersona != 2 &&
                          tipoPersona != 5 &&
                          tipoPersona != 7
                          ? contrato.nombreOriginal
                          : contrato.nombreOriginal.replace(
                              "CONTRATO",
                              "CONTRACT"
                            )
                        : ObtenerTituloArchivo(contrato.tipoDocumento)
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="text-align: center">
            <div
              class="col-s-12 col-md-12 col-lg-4"
              style="display: inline-block; text-align: center"
              v-if="Existe && !FirmandoContratos"
            >
              <button
                v-if="!FirmadosCompleto && !avisoCarga"
                class="
                  btn
                  boton-primario
                  w-100
                  boton-preautorizacion boton-preautorizacion-ajuste
                "
                style="height: 50px"
                v-on:click="FirmarContratos"
                :disabled="!puedeFirmarDocumentos"
              >
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Firmar Contratos"
                    : "Sign Contracts"
                }}
              </button>
            </div>
            <div
              class="col-s-12 col-md-12 col-lg-4"
              style="display: inline-block; text-align: center"
            >
              <strong
                class="descarga-todo"
                v-if="!avisoCarga"
                v-on:click="descargarTodosLosArchivosZip()"
              >
                {{
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? "Descargar todos"
                    : "Download all"
                }}
              </strong>
              <span
                v-if="!avisoCarga"
                v-tooltip.right="
                  tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                    ? 'Debes permitir la descarga multiple en tu navegador, para descargar todos tus contratos, con un solo clic.'
                    : 'You must enable multiple download in your browser, to download all your contracts, with a single click.'
                "
              >
                <i
                  class="fas fa-question-circle icono-ayuda fa-lg"
                  style="padding-left: 20px"
                ></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-lg-12" v-else-if="Existe && FirmandoContratos">
          <div class="p-3 contenedor-loader-firmando">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <label>
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Firmando contratos..."
                  : "Signing contracts..."
              }}
            </label>
          </div>
        </div>
        <div v-else-if="!Existe && !FirmandoContratos" class="col-lg-12">
          <div class="p-3 contratos-vacio">
            <i class="fas fa-business-time contratos-vacio__icono"></i>
            <label class="contratos-vacio__titulo mb-2">
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Se están procesando tus contratos, podrás visualizarlos en un periodo máximo de 72 horas."
                  : "Your contracts are being processed, you will be able to view them within 72 hours."
              }}
            </label>
          </div>
        </div>
        <div v-else-if="avisoCarga" class="col-lg-12">
          <div class="p-3 contratos-vacio">
            <!-- <i class="far fa-folder-open contratos-vacio__icono"></i> -->
            <center>
              <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </center>
            <label class="contratos-vacio__titulo mb-2">
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Cargando Documentos"
                  : "Your documents are being processed, you will be able to view them within 72 hours."
              }}
            </label>
          </div>
        </div>
      </div>
      <div v-if="avisoCarga" class="col-lg-12">
        <div class="p-3 contratos-vacio">
          <!-- <i class="far fa-folder-open contratos-vacio__icono"></i> -->
          <center>
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </center>
          <label class="contratos-vacio__titulo mb-2">
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Cargando Documentos"
                : "Your documents are being processed, you will be able to view them within 72 hours."
            }}
          </label>
        </div>
      </div>
      <div class="row col-lg-12" style="text-align: left">
        <strong class="titulo-documentos">
          {{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "Documentos rellenables"
              : "Fillable documents"
          }}</strong
        >
        <div class="col-lg-12">
          <p class="parrafo-instrucciones">
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Por favor descarga, llena y firma los siguientes documentos, una vez listos vuélvelos a cargar."
                : "Please download, fill out and sign the following documents, once ready re-upload them."
            }}
          </p>
        </div>
        <div
          :class="
            ArchivosGenericos.length > 2
              ? 'col-lg-12 caja-manuales'
              : 'col-lg-12 caja-manuales_dos'
          "
          v-if="ArchivosGenericos.length > 0 && !FirmandoContratos"
        >
          <div
            class="caja-manuales__manual"
            v-for="archivo in ArchivosGenericos"
            :key="archivo.archivoId"
          >
            <strong class="titulo-documentos">{{
              ObtenerTituloArchivo(archivo.tipoDocumento)
            }}</strong>
            <button
              @click.prevent="
                VerArchivo(archivo.archivoId, archivo.tipoDocumento)
              "
              class="caja-manules__boton btn boton-primario"
              data-bs-toggle="modal"
              data-bs-target="#modalArchivo"
              :disabled="!puedeFirmarDocumentos"
            >
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Ver"
                  : "View"
              }}
              {{
                ObtenerTituloArchivo(archivo.tipoDocumento).replace(/ .*/, "")
              }}
            </button>
          </div>
        </div>
        <div
          class="col-lg-12"
          v-else-if="ArchivosGenericos.length > 0 && FirmandoContratos"
        >
          <div class="p-3 contenedor-loader-firmando">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <label>
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Actualizando documentos..."
                  : "Updating documents..."
              }}
            </label>
          </div>
        </div>
        <div
          v-else-if="ArchivosGenericos.length <= 0 && !FirmandoContratos"
          class="col-lg-12"
        >
          <div class="p-3 contratos-vacio">
            <i class="far fa-folder-open contratos-vacio__icono"></i>
            <label class="contratos-vacio__titulo mb-2">
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Se están procesando tus documentos, podrás visualizarlos en un periodo máximo de 72 horas."
                  : "Your documents are being processed, you will be able to view them within 72 hours."
              }}
            </label>
          </div>
        </div>
      </div>
      <div class="row col-lg-12" style="text-align: left">
        <strong class="titulo-documentos">
          {{
            tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
              ? "Documentos de solo lectura"
              : "Read only documents"
          }}</strong
        >
        <div class="col-lg-12">
          <p class="parrafo-instrucciones">
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Podras descargar los siguientes documentos para consulta de información importante para ti."
                : "You will be able to download the following documents to consult important information for you."
            }}
          </p>
        </div>
        <div
          :class="
            ArchivosGenericosSoloLectura.length > 2
              ? 'col-lg-12 caja-manuales'
              : 'col-lg-12 caja-manuales_dos'
          "
          v-if="ArchivosGenericosSoloLectura.length > 0 && !FirmandoContratos"
        >
          <div
            class="caja-manuales__manual"
            v-for="archivo in ArchivosGenericosSoloLectura"
            :key="archivo.archivoId"
          >
            <strong class="titulo-documentos">{{
              ObtenerTituloArchivo(archivo.tipoDocumento)
            }}</strong>
            <button
              @click.prevent="
                VerArchivo(archivo.archivoId, archivo.tipoDocumento)
              "
              class="caja-manules__boton"
              data-bs-toggle="modal"
              data-bs-target="#modalArchivo"
            >
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Ver"
                  : "View"
              }}
              {{
                ObtenerTituloArchivo(archivo.tipoDocumento).replace(/ .*/, "")
              }}
            </button>
          </div>
        </div>
        <div
          class="col-lg-12"
          v-else-if="
            ArchivosGenericosSoloLectura.length > 0 && FirmandoContratos
          "
        >
          <div class="p-3 contenedor-loader-firmando">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <label>
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Actualizando documentos..."
                  : "Updating documents..."
              }}
            </label>
          </div>
        </div>
        <div
          v-else-if="
            ArchivosGenericosSoloLectura.length <= 0 && !FirmandoContratos
          "
          class="col-lg-12"
        >
          <div class="p-3 contratos-vacio">
            <i class="far fa-folder-open contratos-vacio__icono"></i>
            <label class="contratos-vacio__titulo mb-2">
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Se están procesando tus documentos, podrás visualizarlos en un periodo máximo de 72 horas."
                  : "Your documents are being processed, you will be able to view them within 72 hours."
              }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for porgress sings documents -->
    <v-dialog
      v-model="showDialogProgress"
      width="500"
      style="height: 500px;"
      persistent
    >

      <v-card>
        <v-card-title class="text-h5 justify-content-center">
         {{ tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7  ? 'Firma de tus contratos' : 'Contract Signature'  }} 
        </v-card-title>
        <v-card-text>{{ 
        tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7 ? 'Estamos procesando tus contratos' :  'We are processing your contracts' }}</v-card-text>
        <div class="my-5" style="padding: 0 50px;" >
          <v-progress-linear
            color="primary accent-4"
            indeterminate
            rounded
            height="18"
          ></v-progress-linear>
        </div>
        <v-card-actions class="d-flex justify-content-center align-items-center mt-5">
          <v-btn
          style="width: 50%;"
            color="primary"
            outlined
            @click="cancelarSolicitud()"
          >
          {{ tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7 ? 'Cancelar' :  'Cancel' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <transition name="fade" appear>
      <v-alert
    v-if="showAlertFirmaContrato"
  elevation="24"
  color="secondary"
  type="info"
  max-width="450px"
  dismissible
  style="top: 20px; right: 20px; position: fixed; color: #FFF!important; z-index: 9999;"
      id="alert-firma-simple"
>
{{ tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7  ? 'Se canceló el proceso de firma, no se verá reflejada en todos tus contratos' : 'The signature process was cancelled, it will not be reflected in all your contracts.'  }}
</v-alert>
      </transition>
  </div>
</template>

<script>
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import InputDocumentos from "../components/InputDocumentos.vue";
//Plugins
import axios from "axios";
import servicios from "../../../servicios/service.js";
// Mixins
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
//Rutas API
const rutaEnviaCorreoContratosFirmados = "/api/Master/CajaDorada/EnviarCorreoFirmaContratos";
const rutaCargarArchivosGenericos =
  "/api/Master/CajaDorada/CargarDocumentosGenericosCajaDorada";
const rutaCargarContratosCliente = "/api/Master/CajaDorada/CargarContratos";
const rutaDescargarArchivo = "/api/Master/CajaDorada/VerArchivo";
const rutaDescargarArchivoTodos = "/api/Master/Archivo/DescargarArchivo";
const rutaDescargarArchivoZip = "/api/Master/Archivo/DescargarArchivosZip";
const rutaGuardarArchivoLleno = "/api/Master/CajaDorada/GuardarArchivoLleno";
const rutaDescargarContrato = "/api/Master/CajaDorada/DescargarContrato";
const rutaCreaSolicitudInscripcion =
  "/api/Master/CajaDorada/CrearSolicitudInscripcion";
const rutaCreaSolicitudInscripcionMoral =
  "/api/Master/CajaDorada/CrearSolicitudInscripcionMoral";
const rutaCreaGuiaAdjudicatario =
  "/api/Master/CajaDorada/CreaGuiaAdjudicatario";
const rutaValidaTransferenciaDocumentosCore =
  "/api/Master/CajaDorada/ConsultaEstatusDocumentosEmbajadores";
const rutaConsultaArchivosGenericosLlenos =
  "/api/Master/CajaDorada/ConsultaArchivosGenericosLlenos";
const rutaObtenerFigurasAdicionales =
  "/api/Master/FiguraAdicional/ObtenerFiguraAdicionalProspectoPadre";
const rutaCreaAnexoSolicitudPersonaMoral =
  "/api/Master/CajaDorada/CreaAnexoSolicitudPersonaMoral";
const rutaCreaCartaEdad = "/api/Master/CajaDorada/CreaCartaEdad";

const rutaFirmaContratosCliente =
  process.env.VUE_APP_URL_FIRMASIMPLE_API +
  "/api/Master/FirmaSimple/FirmaDigitalDocumentos";
const rutaValidarContratosFirmados =
  "/api/Master/CajaDorada/ValidarContratosFirmados";
const RutaActualizarContratosFirma =
  "/api/Master/CajaDorada/ActualizarContratosFirma";

const rutaConsultarProspectoRepresentante =
  "/api/Master/Prospecto/ObtenerProspectoRepresentanteLegal";

const rutaConsultaSolicitudPreventa =
  "/api/Master/Prospecto/ObtenerSolicitudPreventa";
const rutaVerificarFirmaDigitalProspectoYCoTitulares =
  "/api/Master/Prospecto/VerificarFirmaDigitalProspectoYCoTitulares";

  import { getSession } from "@/Aplicaciones/Masters/apiConnection/api_client";



export default {
  name: "CajaDorada",
  components: {
    TituloSeccion,
    InputDocumentos,
  },
  mixins: [mixinSolicitudInscripcion],
  data() {
    return {
      ProspectoId: null,
      NombreUsuario: "",
      ApellidoUsuario: "",
      ArchivoGenerico: [],
      ArchivosGenericos: [],
      ArchivosGenericosSoloLectura: [],
      ArchivosFirmados: [],
      Contratos: [],
      ContratosFirmados: false,
      ligaArchivo: null,
      tituloDocumento:
        this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
          ? "Documento Hir Casa"
          : "Hir Casa Document",
      documentoLlenar: null,
      tipoDocumentoArchivo: null,
      archivoLleno: null,
      archivoIdActual: null,
      NombreActual:
        this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
          ? "Selecciona un archivo.."
          : "Select a file...",
      subiendoArchivo: false,
      Existe: false,
      tipoUsuario: null,
      tipoPersona: null,
      etapaId: null,
      soloLectura: false,
      FirmandoContratos: false,
      FigurasAdicionales: [],
      Cotitulares: [],
      FirmadosCompleto: false,
      VerificarArchivosGenericos: 0,
      VerificarArchivosGenericosSoloLectura: 0,
      ProspectoRepresentanteLegalId: null,
      avisoCarga: true,
      preventa: false,
      DatosSolicitudGeneral: {
        solicitudId: 0,
        prospectoId: null,
        producto: null,
        servicio: null,
        fechaRegistroSolicitud: null,
        fechaNacimiento: null,
        envioEstadoCuenta: null,
        envioEstadoCuentaOriginal: null,
        enCasoAutorizacion: null,
        requiereFactura: false,
        aceptaInformacionTerceros: false,
        aceptaInformacionPublicitaria: false,
        seccionActual: null,
        solicitudCompletada: false,
      },
      solicitudExistenteId: 0,
      terceraEdad: false,
      SolicitudRepresentanteId: 0,
      SolicitudId: 0,
      showDialogProgress: false,
      cancelTokenSource: null, // Inicialmente, el token de cancelación es nulo,
      showAlertFirmaContrato: false,
      puedeFirmarDocumentos : false,
      personasPendientesFirma: [],
      isMobile: /Mobi/i.test(navigator.userAgent),
      EstadoTitularSinIncodeValor: null,
    };
  },
  async mounted() {
    this.NombreUsuario = sessionStorage.getItem("nombreUsuario");
    this.ApellidoUsuario = sessionStorage.getItem("apellidoUsuario");
    this.etapaId = sessionStorage.getItem("etapaId");
    this.tipoPersona = this.$store.getters.tipoPersona;
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    this.figura = this.$store.getters.tipoFiguraAdicional;
    this.etapaId = this.$store.getters.etapaId;

    if (this.EtapaId != null && this.EtapaId != 9) {
      return;
    }

    await this.ConsultaSolicitudPreventa();
    let idFiguras = (await this.ObtenerFiguraId(this.ProspectoId, 4)).data.data;
    idFiguras.forEach((x) => {
      if (x.tipoPersona == 4 || x.tipoPersona == 5)
        this.Cotitulares.push(x.prospectoId);
    });

    if (
      this.tipoUsuario == 5 ||
      this.tipoUsuario == 6 ||
      this.tipoUsuario == 8 ||
      this.tipoUsuario == 9 ||
      this.tipoUsuario == 10 
    ) {
      this.avisoCarga = false;
      this.FirmadosCompleto = true;
    }

    if (this.tipoPersona == 1) {
      await this.ConsultarProspectoRepresentanteLegal();
    }
    if (this.tipoPersona == 1) {
      await this.ConsultarSolicitudes(this.ProspectoId, true);
      this.solicitudExistenteId = this.SolicitudRepresentanteId;
    } else {
      await this.ConsultarSolicitudes(this.ProspectoId, false);
      this.solicitudExistenteId = this.SolicitudId;
    }
    if (this.solicitudExistenteId != 0) {
      await this.ConsultarSolicitudGeneral(
        this.ProspectoRepresentanteLegalId != 0
          ? this.ProspectoRepresentanteLegalId
          : this.ProspectoId
      );
    }
    if (
      this.DatosSolicitudGeneral.fechaNacimiento != null &&
      this.DatosSolicitudGeneral.fechaNacimiento != ""
    ) {
      let fechaActual = new Date().getFullYear();
      let edad = new Date(this.DatosSolicitudGeneral.fechaNacimiento).getFullYear();
      let resultado = fechaActual - edad;
      if (resultado >= 60) {
        this.terceraEdad = true;
      }
    }

    //Regla para mostrar solo al prospecto los documentos
    if (
      this.tipoUsuario == 3 ||
      this.tipoUsuario == 5 ||
      this.tipoUsuario == 6 ||
      this.tipoUsuario == 8 ||
      this.tipoUsuario == 9 ||
      this.tipoUsuario == 10 
    ) {
      await this.ValidaTransferenciaDocumentosCore();
      if (this.Existe) {
        await this.ObtenerFigurasAdicionales();
        await this.ObtenerArchivosGenericos();
        await this.ObtenerContratosCliente();
      }
      if (
        this.tipoUsuario == 5 ||
        this.tipoUsuario == 6 ||
        this.tipoUsuario == 8 ||
        this.tipoUsuario == 9 ||
        this.tipoUsuario == 10
      ) {
        this.avisoCarga = false;
        this.FirmadosCompleto = true;
      }
    } else {
      this.$fire({
        title:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "Aviso de privacidad"
            : "Privacy Notice",
        text:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "La visualización y firma de documentos esta limtada al titular del contrato, revisa la información sobre protección de datos mencionada en nuestro aviso de privacidad."
            : "The viewing and signing of documents is limited to the contract holder, please review the data protection information mentioned in our privacy notice.",
        confirmButtonText:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "Aceptar"
            : "Accept",
      });
    }
    if (!this.Existe && !this.FirmandoContratos) {
      this.avisoCarga = false;
    }

    /**
     * Validar si cuenta con incode para firmar contratos 
     * #Incremento_6525
     */
     await this.tienenIncodeCompletado()

     /**
      * Validar si cuenta con Incode el titular 
      */
      await this.EsTitularSinIncode()

    
  },
  methods: {
    inglesEval(){
      return this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
          ? false
          : true
    },
    async ConsultaSolicitudPreventa() {
      const prospecto = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      await axios
        .get(rutaConsultaSolicitudPreventa, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.preventa = resp.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async ConsultarProspectoRepresentanteLegal() {
      const prospecto = {
        params: {
          ProspectoId: this.ProspectoId
        }
      };
      await axios
        .get(rutaConsultarProspectoRepresentante, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.ProspectoRepresentanteLegalId = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async ValidaContratosFirmados() {
      const cliente = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      await axios
        .get(rutaValidarContratosFirmados, cliente)
        .then(async (resp) => {
          if (resp.data.estado === 0) {
            this.avisoCarga = false;
            this.ContratosFirmados = resp.data.data;
            this.FirmadosCompleto = this.ContratosFirmados;
            await this.ObtenerContratosCliente();
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async FirmarContratos() {
      this.$fire({
        title:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "Firma de tus contratos"
            : "Sign your contracts",
        text:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "Para continuar, deberás aceptar que se realice la firma digital de todos tus contratos."
            : "To continue, you must agree to digitally sign all your contracts.",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "Aceptar y firmar"
            : "Accept and sign",
        cancelButtonText:
          this.tipoPersona != 2 &&
          this.tipoPersona != 5 &&
          this.tipoPersona != 7
            ? "Cancelar"
            : "Cancel",
        allowOutsideClick: true,
      }).then(async (result) => {
        if (result.value) {
          this.showDialogProgress = true;
          await this.FirmaContratos();
                }
      });
    },
    VerArchivo(archivoId, tipoDocumento) {
      // if(this.tipoUsuario == 5)
      // {
      //   return;
      // }

      this.archivoIdActual = archivoId;
      switch (tipoDocumento) {
        case 18:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Manual del Consumidor"
              : "Consumer Handbook";
          this.soloLectura = true;
          this.tipoDocumentoArchivo = 18;
          break;
        case 19:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Guía de Adjudicatario"
              : "Adjudicator's Guide";
          this.soloLectura = false;
          this.tipoDocumentoArchivo = 19;
          break;
        case 20:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Tríptico de seguros"
              : "Insurance Triptych";
          this.soloLectura = true;
          this.tipoDocumentoArchivo = 20;
          break;
        case 21:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Consentimiento Médico"
              : "Medical Consent";
          this.soloLectura = false;
          this.tipoDocumentoArchivo = 21;
          break;
        case 22:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Consentimiento Seguros"
              : "Insurance Consent";
          this.soloLectura = false;
          this.tipoDocumentoArchivo = 22;
          break;
        case 26:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Adicional Financiera"
              : "Additional Financial";
          this.soloLectura = false;
          this.documentoLlenar = 26;
          this.tipoDocumentoArchivo = 26;
          break;
        case 27:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Actividad Profesional"
              : "Professional Activity";
          this.soloLectura = false;
          this.tipoDocumentoArchivo = 27;
          break;
        case 28:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Calendario de eventos"
              : "Event Calendar";
          this.soloLectura = true;
          this.tipoDocumentoArchivo = 28;
          break;
        case 23:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Contrato"
              : "Contract";
          this.soloLectura = true;
          break;
        case 24:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Hoja de Prueba"
              : "Test Sheet";
          this.soloLectura = true;
          break;
        case 25:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Kit de Contratacion"
              : "Hiring Kit";
          this.soloLectura = true;
          break;
        case 31:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Solicitud de Inscripción Cotitular"
              : "Co-Holder Registration Request";
          this.soloLectura = true;
          break;
        case 32:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Solicitud de Inscripción Representante Legal"
              : "Legal Representative Registration Request";
          this.soloLectura = true;
          break;
        case 33:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Solicitud de Inscripción Moral"
              : "Moral Registration Request";
          this.soloLectura = true;
          break;
        case 34:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Anexo Solicitud de Inscripción Moral"
              : "Moral Registration Request Attachment";
          this.soloLectura = true;
          break;
        case 35:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Carta Edad"
              : "Age Letter";
          this.soloLectura = true;
          break;
        case 36:
          this.tituloDocumento = "Adjudicators Guide";
          this.soloLectura = true;
          break;
        case 37:
          this.tituloDocumento = "Award Notification";
          this.soloLectura = true;
          break;
        case 38:
          this.tituloDocumento = "Calendar Of Events";
          this.soloLectura = true;
          break;
        case 39:
          this.tituloDocumento = "Consumer Handbook";
          this.soloLectura = true;
          break;
        case 40:
          this.tituloDocumento = "Hircasa Contract";
          this.soloLectura = true;
          break;
      }
      this.ligaArchivo =
        rutaDescargarArchivo +
        "?archivoId=" +
        archivoId +
        "&prospectoId=" +
        this.ProspectoId +
        "&tipoDocumento=" +
        tipoDocumento;
      window.frames[0].contentWindow.location.reload();
    },
    VerContrato(archivoId, tipoDocumento, nombreDocumento) {
      // if(this.tipoUsuario == 5)
      // {
      //   return;
      // }

      this.soloLectura = true;
      switch (tipoDocumento) {
        case 19:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Guía de Adjudicatario"
              : "Adjudicator's Guide";
          break;
        case 23:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? nombreDocumento
              : nombreDocumento.replace("CONTRATO", "CONTRACT");
          break;
        case 24:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Hoja de Prueba"
              : "Test Sheet";
          break;
        case 25:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Kit de Contratacion"
              : "Hiring Kit";
          break;
        case 29:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Solicitud de Inscripción"
              : "Registration Request";
          break;
        case 31:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Solicitud de Inscripción Cotitular"
              : "Co-Holder Registration Request";
          break;
        case 32:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Solicitud de Inscripción Representante Legal"
              : "Legal Representative Registration Request";
          break;
        case 33:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Solicitud de Inscripción Moral"
              : "Moral Registration Request";
          break;
        case 34:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Anexo Solicitud de Inscripción Moral"
              : "Moral Registration Request Attachment";
          break;
        case 35:
          this.tituloDocumento =
            this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Carta Edad"
              : "Age Letter";
          break;
        case 36:
          this.tituloDocumento = "Adjudicators Guide";
          break;
        case 37:
          this.tituloDocumento = "Award Notification";
          break;
        case 38:
          this.tituloDocumento = "Calendar Of Events";
          break;
        case 39:
          this.tituloDocumento = "Consumer Handbook";
          break;
        case 40:
          this.tituloDocumento = "Hircasa Contract";
          break;
      }
      this.ligaArchivo = rutaDescargarContrato + "?archivoId=" + archivoId;
      window.frames[0].contentWindow.location.reload();
      //window.frames['frameNameOrIndex'].location.reload();
      //document.getElementById('iframeid').src = document.getElementById('iframeid').src
    },
    async ObtenerFigurasAdicionales() {
      this.FigurasAdicionales = [];
      const prospectoPadreId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaObtenerFigurasAdicionales, prospectoPadreId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.FigurasAdicionales = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async ObtenerContratosCliente() {
      this.Contratos = [];
      const cliente = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      await axios
        .get(rutaCargarContratosCliente, cliente)
        .then(async (resp) => {
          if (resp.data.estado === 0) {
            this.avisoCarga = false;
            this.Contratos = resp.data.data;
            if (!this.ContratosFirmados) {
              await this.ValidaContratosFirmados();
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async ObtenerArchivosGenericos() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId,
        },
      };
      /**
       * Fix a BUG : #5281
       * Al firmar los documentos adicionales se borran los manuales 
       * 
       * Se restablece contadores para obtener los documentos correctos despues de subir un archivo 
       */
      this.VerificarArchivosGenericosSoloLectura = 0
      this.VerificarArchivosGenericos = 0
      await axios
        .get(rutaCargarArchivosGenericos, prospecto)
        .then(async resp => {
          if (resp.data.estado === 0) {
            this.ArchivosGenericos.splice(0);
            this.ArchivosGenericosSoloLectura.splice(0);
            var arregloArchivos = resp.data.data;
            arregloArchivos.forEach(a => {
              if (
                a.tipoDocumento == 18 ||
                a.tipoDocumento == 20 ||
                a.tipoDocumento == 36 ||
                a.tipoDocumento == 37||
                a.tipoDocumento == 38 ||
                a.tipoDocumento == 39 ||
                a.tipoDocumento == 40
              ) {
                if (this.VerificarArchivosGenericosSoloLectura <= 6) {
                  this.ArchivosGenericosSoloLectura.push(a);
                  this.VerificarArchivosGenericosSoloLectura += 1;
                }
              } else {
                if (this.VerificarArchivosGenericos <= 6) {
                  this.ArchivosGenericos.push(a);
                  this.VerificarArchivosGenericos += 1;
                }
              }
            });
            if (this.tipoDocumentoArchivo != null) {
              this.ligaArchivo =
                rutaDescargarArchivo +
                "?archivoId=" +
                0 +
                "&prospectoId=" +
                this.ProspectoId +
                "&tipoDocumento=" +
                this.tipoDocumentoArchivo;
              //this.NombreActual = resp.data.data;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ObtenerTituloArchivo(tipo) {
      switch (tipo) {
        case 18:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Manual del Consumidor"
            : "Consumer Handbook";
        case 19:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Guía de Adjudicatario"
            : "Adjudicator's Guide Esp";
        case 20:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Tríptico de seguros"
            : "Insurance Triptych";
        case 21:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Consentimiento Médico"
            : "Medical Consent";
        case 22:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Consentimiento Seguros"
            : "Insurance Consent";
        case 23:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Contrato"
            : "Contract";
        case 24:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Hoja de Prueba"
            : "Proof Sheet";
        case 25:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Kit de Contratacion"
            : "Contract Kit";
        case 26:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Adicional Financiera"
            : "Financial Additional";
        case 27:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Actividad Profesional"
            : "Professional Activity";
        case 28:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Calendario de eventos"
            : "Calendar of Events";
        case 29:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Solicitud de Inscripción"
            : "Registration Request";
        case 31:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Solicitud de Inscripción Cotitular"
            : "Co-Holder Registration Request";
        case 32:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Solicitud de Inscripción Representante Legal"
            : "Legal Representative Registration Request";
        case 33:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "Solicitud de Inscripción Moral"
            : "Moral Registration Request";
        case 34:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Anexo Solicitud de Inscripción Moral"
              : "Moral Registration Request Attachment";
        case 35:
          return this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
              ? "Carta Edad"
              : "Age Letter";
        case 36:
          return "Adjudicators Guide En";
        case 37:
          return "Award Notification En";
        case 38:
          return "Calendar Of Events En";
        case 39:
          return "Consumer Handbook En";
        case 40:
          return "Hircasa Contract En";
      }
    },
    async CreaSolicitudInscripcion() {
      const paqueteDeDatos = {
        params: {
          prospectoId: this.ProspectoId,
          tipoDocumento: 29,
        },
      };
      try {
        await axios.get(rutaCreaSolicitudInscripcion, paqueteDeDatos);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async CreaSolicitudInscripcionCotitular(cotitularId) {
      const paqueteDeDatos = {
        params: {
          prospectoId: cotitularId,
          tipoDocumento: 31,
        },
      };
      try {
        await axios.get(rutaCreaSolicitudInscripcion, paqueteDeDatos);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async CreaSolicitudInscripcionMoral(ProspectoMoralId) {
      const paqueteDeDatos = {
        params: {
          prospectoId: ProspectoMoralId,
          tipoDocumento: 33,
        },
      };
      try {
        await axios.get(rutaCreaSolicitudInscripcionMoral, paqueteDeDatos);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async CreaSolicitudInscripcionRepresentanteLegal(
      ProspectoRepresentanteLegalId
    ) {
      const paqueteDeDatos = {
        params: {
          prospectoId: ProspectoRepresentanteLegalId,
          tipoDocumento: 32,
        },
      };
      try {
        await axios.get(rutaCreaSolicitudInscripcion, paqueteDeDatos);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async CreaGuiaAdjudicatario() {
      const cliente = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaCreaGuiaAdjudicatario, cliente)
        .then(() => {})
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async CreaAnexoSolicitudPersonaMoral() {
      const cliente = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaCreaAnexoSolicitudPersonaMoral, cliente)
        .then(() => {})
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async CreaCartaEdad() {
      const cliente = {
        params: {
          ProspectoId: this.ProspectoId
        },
      };
      axios
        .get(rutaCreaCartaEdad, cliente)
        .then(() => {})
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    almacenarArchivoLleno(event) {
      this.archivoLleno = event.target.files[0];
      this.subirArchivoLleno();
    },
    activaInput() {
      this.$refs["inputDocumentoLleno"].click();
    },
    async subirArchivoLleno() {
      if (this.ProspectoId != null) {
        if (this.archivoLleno === null) {
          this.$fire({
            title:
              this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
                ? "Carga de archivo"
                : "File upload",
            html:
              this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
                ? "<br>Debe cargar un archivo<br><br>"
                : "<br>You must upload a file<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText:
              this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
                ? "Aceptar"
                : "Accept",
          });
          return;
        }

        if (!servicios.validarFormatoArchivoValido(this.archivoLleno)) {
          this.$fire({
            title:
              this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
                ? "Formato de archivo inválido"
                : "Invalid file format",
            html:
              this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
                ? "<br>El archivo que cargaste no cuenta con las características:<br>" +
                  "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>"
                : "<br>The file you uploaded does not have the features:<br>" +
                  "Valid format: pdf, png, jpg, office. Maximum size: 40mb per file.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText:
              this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
                ? "Aceptar"
                : "Accept",
          });
          return;
        }

        if (!servicios.validarTamanioArchivoValido(this.archivoLleno)) {
          this.$fire({
            title:
              this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
                ? "Peso máximo"
                : "Maximum weight",
            html:
              this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
                ? "<br>El archivo sobrepasa el tamaño permitido<br><br>"
                : "<br>The file exceeds the maximum size<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText:
              this.tipoPersona != 2 &&
              this.tipoPersona != 5 &&
              this.tipoPersona != 7
                ? "Aceptar"
                : "Accept",
          });
          return;
        }

        this.subiendoArchivo = true;
        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("archivo", this.archivoLleno);
        paqueteDeDatos.append("tipoDocumento", this.tipoDocumentoArchivo);
        await axios
          .post(rutaGuardarArchivoLleno, paqueteDeDatos)
          .then(async (resp) => {
            if (resp.data.estado === 0) {
              this.subiendoArchivo = false;

              //Firma de Generico
              var consultaArchivo = new FormData();
              consultaArchivo.append("prospectoId", this.ProspectoId);
              consultaArchivo.append(
                "tipoDocumento",
                this.tipoDocumentoArchivo
              );
              await axios
                .post(rutaConsultaArchivosGenericosLlenos, consultaArchivo)
                .then(async (respFirma) => {
                  if (respFirma.data.estado === 0) {
                    if (respFirma.data.data[0].Detalle != "FIRMADO") {
                      this.ArchivoGenerico = respFirma.data.data;
                      await this.FirmaGenericos();
                    }
                    //Seccion de consulta agregada ya que solo se consultaban los archivos genericos si no estaban firmados
                    else {
                      await this.ObtenerArchivosGenericos();
                    }
                  }
                })
                .catch((e) => {
                  this.subiendoArchivo = false;
                  this.ManejarExcepcion(e);
                });
              this.subiendoArchivo = false;
             
              this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
            } else if (resp.data.estado === 1) {
              this.subiendoArchivo = false;
              this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
            }
          })
          .catch((e) => {
            this.subiendoArchivo = false;
            this.ManejarExcepcion(e);
          });
      }
    },

    async ActualizarGenericosFirma() {
      let objetoPrueba = {
        prospectoId: this.ProspectoId,
        archivo: this.ArchivoGenerico,
      };
      await axios
        .post(RutaActualizarContratosFirma, objetoPrueba)
        .then(async resp => {
          if (resp.data.estado === 0) {
            await this.ObtenerArchivosGenericos();
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async EnviaCorreoContratosFirmados() {
      await axios
        .post(rutaEnviaCorreoContratosFirmados + "?prospectoId=" + this.ProspectoId)
        .then(async resp => {
          console.log(resp);
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async ActualizarContratosFirma() {
      // Crear un nuevo objeto CancelToken antes de cada solicitud
      this.cancelTokenSource = axios.CancelToken.source();
          let objetoPrueba = {
            prospectoId: this.ProspectoId,
            archivo: this.ArchivosFirmados,
          };
          await axios
            .post(RutaActualizarContratosFirma, objetoPrueba, {
          cancelToken: this.cancelTokenSource.token, // Incluir el token de cancelación
        })
        .then(async resp => {
          if (resp.data.estado === 0) {
            this.ContratosFirmados = true;
            await this.ObtenerContratosCliente();
            await this.EnviaCorreoContratosFirmados();
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
          if (axios.isCancel(e)) {
      // La solicitud fue cancelada, puedes manejarlo aquí
      this.FirmandoContratos = false;
      this.showDialogProgress = false;
      this.MostrarAlertCancelarAccion()
    } 
  
        });
    },
    //ArchivosFirmados-Generico
    //ArchivosFirmados
    async FirmaGenericos() {
      let objetoPrueba = {
        prospectoId:
          this.tipoPersona == 1
            ? this.ProspectoRepresentanteLegalId
            : this.ProspectoId,
        archivos: this.ArchivoGenerico,
        AplicacionId: 0,
        figuras: this.FigurasAdicionales,
        representanteLegal:
          this.tipoPersona == 1 ? this.ProspectoRepresentanteLegalId : 0,
        preventa: this.preventa,
      };
      axios
        .post(rutaFirmaContratosCliente, objetoPrueba)
        .then(resp => {
          if (resp.data.estado === "OK") {
            this.ArchivoGenerico = resp.data.data;
            this.ActualizarGenericosFirma();
          } else {
            this.AlertaEmbajadores(resp.data.mensaje, true, this.inglesEval());
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },

    //ArchivosFirmados-Contratos
    async FirmaContratos() {
      
      this.showDialogProgress = true;
      this.FirmandoContratos = true;
      // Crear un nuevo objeto CancelToken antes de cada solicitud
      this.cancelTokenSource = axios.CancelToken.source();
      let objetoPrueba = {
        prospectoId:
          this.tipoPersona == 1
            ? this.ProspectoRepresentanteLegalId
            : this.ProspectoId,
        archivos: this.Contratos,
        AplicacionId: 0,
        figuras: this.FigurasAdicionales,
        representanteLegal:
          this.tipoPersona == 1 ? this.ProspectoRepresentanteLegalId : 0,
        preventa: this.preventa,
      };

      try {
        const { data } = await axios.post(rutaFirmaContratosCliente, objetoPrueba, {
          cancelToken: this.cancelTokenSource.token, // Incluir el token de cancelación
        });

        if (data.estado == 'OK') {
          this.ArchivosFirmados = data.data;
          await this.ActualizarContratosFirma();
          this.FirmandoContratos = false;
          await this.ValidaContratosFirmados();
        } else {
          this.FirmandoContratos = false;
          this.AlertaEmbajadores(data.mensaje, true, this.inglesEval());
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          // La solicitud fue cancelada, puedes manejarlo aquí
          this.FirmandoContratos = false;
          this.showDialogProgress = false;
          this.MostrarAlertCancelarAccion()
        } 
      } finally {
        this.showDialogProgress = false;
      }
    },
    cancelarSolicitud() {
      // Cuando el usuario hace clic en el botón "Cancelar"
      this.cancelTokenSource.cancel('La solicitud ha sido cancelada por el usuario');

    },

    MostrarAlertCancelarAccion (){
      this.showAlertFirmaContrato = true;
      setTimeout(() => {
        this.showAlertFirmaContrato= false;
      }, 5000); // 5000 milisegundos = 5 segundos
    },

    async ValidaTransferenciaDocumentosCore() {
      const prospectoId = {
        params: {
          ProspectoId: this.ProspectoId,
          AplicacionId: 0
        }
      };
      try {
        let resp = await axios.get(
          rutaValidaTransferenciaDocumentosCore,
          prospectoId
        );
        this.Existe = resp.data.data;
        if (this.Existe) {
          this.Cotitulares.forEach(async x => {
            await this.CreaSolicitudInscripcionCotitular(x);
          });
          if (this.tipoPersona == 1) {
            await this.CreaSolicitudInscripcionMoral(this.ProspectoId);
            //Aqui se crea solicitud de moral
            await this.CreaSolicitudInscripcionRepresentanteLegal(
              this.ProspectoRepresentanteLegalId
            );
            await this.CreaAnexoSolicitudPersonaMoral(this.ProspectoId);
          } else {
            await this.CreaSolicitudInscripcion();
          }
          if (this.tipoPersona == 2) {
            await this.CreaSolicitudInscripcion();
          }
          await this.CreaGuiaAdjudicatario();
          if (this.terceraEdad) {
            await this.CreaCartaEdad(this.ProspectoId);
          }
        }
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    descargarTodosLosArchivosZip() {
      if (this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
        return;
      }
      //No dejar espacios en el nombre
      var nombreZip =
        this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
          ? "DocumentosCajaDorada"
          : "DocumentsGoldenCase";
      var archivosPorDescargar = this.Contratos.slice();

      var archivosIdJson;
      var archivosIdArray = new Array();

      archivosPorDescargar.forEach(function(value) {
        archivosIdArray.push(value.archivoId);
      });

      archivosIdJson = JSON.stringify(archivosIdArray);

      if (archivosPorDescargar.length > 0) {
        window.location.href =
          rutaDescargarArchivoZip +
          "?archivosIdJson=" +
          archivosIdJson +
          "&nombreZip=" +
          nombreZip;
      } else {
        this.AlertaEmbajadores(
          this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "No hay contratos para descargar."
            : "There are no contracts to download.",
          true,
          this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? false
            : true
        );
      }
    },

    descargarTodosLosArchivos() {
      var archivosPorDescargar = this.Contratos.slice();
      if (archivosPorDescargar.length > 0) {
        archivosPorDescargar.forEach(function(value, index) {
          setTimeout(() => {
            window.location.href =
              rutaDescargarArchivoTodos + "?archivoId=" + value.archivoId;
          }, index * 100);
        });
      } else {
        this.AlertaEmbajadores(
          this.tipoPersona != 2 &&
            this.tipoPersona != 5 &&
            this.tipoPersona != 7
            ? "No hay contratos para descargar."
            : "There are no contracts to download.",
          true,
          this.inglesEval()
        );
      }
    },
    async tienenIncodeCompletado (){
        const { data } =  await axios(rutaVerificarFirmaDigitalProspectoYCoTitulares+'?prospectoId='+this.ProspectoId)
        this.puedeFirmarDocumentos = data.data.every((persona) => persona.TieneOnboarding === true)
        this.personasPendientesFirma = data.data.filter((persona) => persona.TieneOnboarding === false)
    },
    goTo(){
      this.$store.commit('setGoToSinOnboarding', {to:'CajaDorada'}) //this.route.name 
      if (this.isMobile) {
        this.$router.push({ name: "WelcomeOnBoarding" });
      } else {
        this.$router.push({ name: "InformacionAutenticacionIdentidad" });
      }
    },
    async EsTitularSinIncode(){
      const session = await getSession(this.ProspectoId);
      if((session != null || session != undefined ) && (this.tipoPersona == 0 || this.tipoPersona == 2)){
        session.finishStatus === 'COMPLETE' ? this.EstadoTitularSinIncodeValor = false : this.EstadoTitularSinIncodeValor = true 
      }
      if( session == null && (this.tipoPersona == 0 || this.tipoPersona == 2)){
        this.EstadoTitularSinIncodeValor = true 
      } 
    }
  },
  computed:{
    LabelInputFile (){
      return  this.tipoPersona != 2 && this.tipoPersona != 5 && this.tipoPersona != 7
          ? "Selecciona un archivo..."
          : "Select a file..."
    },
    
  }
};
// Comentarios Random
</script>

<style lang="scss" scoped>
@import "../../../../../assets/estilos/estilosgenerales.scss";
.principal-caja-dorada {
  width: 100vw;
  flex-grow: 1;
}
.titulo-documentos {
  color: $negro-embajadores;
}
.accordion-item {
  border-style: none !important;
}
.accordion-button {
  display: flex;
  border-radius: 0 !important;
  background-color: $color-primario !important;
  color: white !important;
  font-family: $poppins;
  text-align: center !important;
}
.boton--collapsable {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0;
  background-color: $color-primario;
  color: white;
  font-family: $poppins;
  width: 100%;
  padding: 15px;
}
.boton--collapsable::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 15px;
  content: "";
  background-image: url("../../../../../assets/iconos-embajadores/arrowhite.png");
  transition: transform 0.2s ease-in-out;
  background-position-y: 4px;
}
.boton--collapsable:hover {
  color: $blanco;
}
.boton--collapsable:focus {
  outline: none;
  box-shadow: none;
}
.boton--collapsable:not(:not(.collapsed))::after {
  transform: rotate(0deg);
}
.boton--collapsable:not(.collapsed)::after {
  transform: rotate(-180deg);
}
.descarga-todo {
  color: $color-primario;
  text-decoration: underline;
  cursor: pointer;
  line-height: 3.5;
}
.caja-manuales {
  display: grid;
  column-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
.caja-manuales_dos {
  display: grid;
  column-gap: 25px;
  grid-template-columns: repeat(2, 1fr);
}
.caja-manuales__manual {
  margin-top: 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.caja-manuales__manual strong {
  font-size: 14px;
  margin-bottom: 10px;
}
.caja-manules__boton {
  background: $color-primario;
  color: white;
  height: 57px;
  transition: 0.5s;
}
.caja-manules__boton:hover {
  background: #9e624e;
}

.contratos-vacio {
  display: flex;
  justify-content: center;
  background: #ffd9cd;
  flex-direction: column;
}
.contratos-vacio__titulo {
  text-align: center;
  font-weight: bold;
}
.contratos-vacio__icono {
  font-size: 32px;
  margin-bottom: 10px;
  text-align: center;
}

//MODAL ARCHIVO
.principal-caja-dorada .modal-dialog {
  width: 100%;
}
.principal-caja-dorada .modal-archivo {
  border-radius: 0px;
  height: 90vh;
}
.principal-caja-dorada .modal-archivo__encabezado {
  border-style: none;
}
.principal-caja-dorada .pdf-archivo {
  width: 100%;
  height: 100%;
}

.principal-caja-dorada .modal-archivo .modal-archivo__boton {
  background: $color-primario;
  border-radius: 0px;
  border-style: none;
}

/* LOADER */
.contenedor-loader-firmando {
  background-color: #fad4c8;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.contenedor-loader-firmando label {
  animation: blinker 1.5s linear infinite;
  font-weight: 500;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #b8725a;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

@media all and (max-width: 767px) {
  .descarga-todo {
    text-align: right;
  }
  .acordeon-embajadores__caja-contratos {
    grid-template-columns: repeat(2, 1fr);
  }
  .caja-manuales {
    grid-template-columns: repeat(2, 1fr);
  }
  .contratos-vacio__titulo {
    font-size: 12px;
    text-align: center;
    font-weight: bold;
  }
}
</style>
